export const trendingImages = [
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166399/bchaskxexutj9aogx7er.jpg",
        url: "/product/64aa8da1a4ceca15db51f10c"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166986/waaesobca0f4lst7jbaq.jpg",
        url: "/product/64aa8dd6a4ceca15db51f110"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167017/osapgr8ri4l0msn5aaev.jpg",
        url: "/product/64aa8e3da4ceca15db51f11c"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167072/vsl2di64gm1ohavozzxq.jpg",
        url: "/product/64aa8e7ea4ceca15db51f120"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167162/lbsod5ktrchrtps0z0bw.jpg",
        url: "/product/64aa8eb3a4ceca15db51f124"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167205/clpndik8398wpe3lvcyn.jpg",
        url: "/product/64aa8f09a4ceca15db51f128"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167253/i16wgywcl3pfk8ibkbxv.jpg",
        url: "/product/64aa8f57a4ceca15db51f12c"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167313/d6kwduyhd8pvvxx4syq8.jpg",
        url: "/product/64aa8fc2a4ceca15db51f130"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167371/ygjkk5d8203lfs9uhixk.jpg",
        url: "/product/64aa9000a4ceca15db51f134"
    },
    {
        name: "",
        img: "http://res.cloudinary.com/deo80u7qs/image/upload/v1688167465/r05oji4bvgk1blkibc7a.jpg",
        url: "/product/64aa902da4ceca15db51f138"
    }
]

export const heroImages = [
    "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166240/innumwhyuwydtcsia3q0.jpg",
    "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166300/opn1jmrbcq6uxfgz00en.jpg",
    "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166344/f1ixwxv2oxrngfwgak7u.jpg",
    "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166370/vhjrsrujah2vszemxqs0.jpg",
    "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166399/bchaskxexutj9aogx7er.jpg",
    "http://res.cloudinary.com/deo80u7qs/image/upload/v1688166419/tnmmj0onluaxazx3pfq4.jpg"
];